if (!customElements.get('oy-size-guide')) {
  customElements.define('oy-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', (event) => {
        const dialog = this.querySelector('dialog');
        if (event.target.closest('.oy-size-guide__btn')) dialog.showModal();
        if (event.target.closest('[data-close]')) dialog.close();
        const unit = event.target.closest('[data-unit]');
        if (!unit) return;
        this.querySelectorAll('[data-unit]').forEach(button => {
          button.classList.toggle('is-active', button === unit);
          button.setAttribute('aria-pressed', String(button === unit));
        });
        this.querySelectorAll('[data-in]').forEach(cell => {
          cell.textContent = unit.dataset.unit === 'cm'
            ? String(Math.round(Number(cell.dataset.in) * 25.4) / 10) : cell.dataset.in;
        });
      });
    }
  });
}
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-oy-open-size]');
  if (!link) return;
  const dialog = link.closest('product-info')?.querySelector('oy-size-guide dialog');
  if (dialog) { event.preventDefault(); dialog.showModal(); }
});

document.addEventListener('click', (event) => {
  const apply = event.target.closest('[data-oy-apply-filters]');
  const back = event.target.closest('.mobile-facets__close-button');
  const control = apply || back;
  const drawer = control?.closest('menu-drawer');
  if (!drawer) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (apply) {
    const summary = drawer.querySelector('summary');
    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
  } else {
    drawer.closeSubmenu(back.closest('details'));
  }
}, true);
